angular
    .module('TV')
    .factory('TVService', ['$http', '$q', '__env', '$filter', function TVService($http, $q, __env, $filter) {

        var serviceUrl = __env.apiUrl;
        var TVIndicadoresUrl = 'tokens';

        function getToken() {
            return $http.get(serviceUrl + TVIndicadoresUrl + '/refresh/');
        }

        function getSitioInspeccion(inspeccionId) {
            return $http.get(serviceUrl + TVIndicadoresUrl + '/sitioInspeccion/' + inspeccionId);
        }

        function getSitioInspeccionADIF(inspeccionADIFId) {
            return $http.get(serviceUrl + TVIndicadoresUrl + '/sitioInspeccionADIF/' + inspeccionADIFId);
        }


        function getSitioVisualizacion(infraestructuraId) {
            return $http.get(serviceUrl + TVIndicadoresUrl + '/sitioVisualizacion/' + infraestructuraId);
        }


        return {
            getToken: getToken,
            getSitioInspeccion: getSitioInspeccion,
            getSitioVisualizacion: getSitioVisualizacion,
            getSitioInspeccionADIF: getSitioInspeccionADIF

        }
    }]);